@let d = data();
<article class="alert-confirmation">
  <div class="alert-confirmation__card">
    <header class="alert-confirmation__summary-header alert-confirmation__summary-header--{{ headerVariant() }}">
      <strong>Notify summary</strong>
    </header>

    <div class="alert-confirmation__body">
      @if (d.message) {
        <p class="alert-confirmation__intro">{{ d.message }}</p>
      }

      @if (countryFlag()) {
        <p class="alert-confirmation__flag" aria-hidden="true">{{ countryFlag() }}</p>
      }
      <h1 class="alert-confirmation__course">
        {{ course().name }}
        @if (locationDisplay()) {
          <span class="alert-confirmation__course-sub">{{ locationDisplay() }}</span>
        }
      </h1>

      <section class="alert-confirmation__section">
        <h2 class="alert-confirmation__section-title">Tee Time</h2>
        <ul class="alert-confirmation__meta">
          @if (criteria()?.displayTime || criteria()?.appointmentTime) {
            <li>
              <span aria-hidden="true">🕒</span>
              {{ criteria()?.displayTime || (criteria()?.appointmentTime | date:'h:mm a') }}
            </li>
          }
          @if (criteria()?.isoDate || criteria()?.date) {
            <li>
              <span aria-hidden="true">📆</span>
              {{ criteria()?.date || (criteria()?.isoDate | date:'EEE. d MMM yyyy') }}
            </li>
          }
          @if (criteria()?.players != null) {
            <li><span aria-hidden="true">🏌️‍♂️</span> {{ criteria()?.players }} players</li>
          }
          @if (criteria()?.holes != null) {
            <li><span aria-hidden="true">⛳️</span> {{ criteria()?.holes }} Holes</li>
          }
        </ul>
      </section>

      @if (customer(); as user) {
        <section class="alert-confirmation__section">
          <h2 class="alert-confirmation__section-title">Your details</h2>

          <div class="alert-confirmation__contact">
            <span class="alert-confirmation__contact-avatar">
              @if (user.avatarUrl) {
                <img [src]="user.avatarUrl" [alt]="user.name || ''" width="32" height="32">
              } @else if (currentUser()?.imageUrl) {
                <img [src]="currentUser()?.imageUrl" [alt]="user.name || ''" width="32" height="32">
              } @else {
                <img src="assets/images/userAvatarIcon.svg" alt="" width="32" height="32">
              }
            </span>
            @if (user.name) {
              <span class="alert-confirmation__contact-name">{{ user.name }}</span>
            }
          </div>

          @if (user.email) {
            <div class="alert-confirmation__field alert-confirmation__field--readonly">
              <span class="alert-confirmation__field-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.6" />
                  <path d="m3 7 9 6 9-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              <span>{{ user.email }}</span>
            </div>
          }

          @if (user.phone) {
            <div class="alert-confirmation__field alert-confirmation__field--bordered">
              <span class="alert-confirmation__field-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
                </svg>
              </span>
              <span>{{ user.phone }}</span>
            </div>
          }
        </section>
      }

      @if (costSummary(); as cost) {
        <section class="alert-confirmation__section">
          <h2 class="alert-confirmation__section-title">Cost Summary</h2>
          <ul class="alert-confirmation__cost">
            @for (line of cost.perPlayer; track $index) {
              <li>
                <span class="alert-confirmation__cost-label">{{ line.label }}</span>
                <span class="alert-confirmation__cost-amount alert-confirmation__cost-amount--muted">
                  @if (line.displayText) {
                    {{ line.displayText }}
                  } @else {
                    {{ line.amount | currency:currency():'symbol':'1.2-2' }}
                  }
                </span>
              </li>
            }
            <li>
              <span class="alert-confirmation__cost-label">Booking fee</span>
              <span class="alert-confirmation__cost-amount">
                {{ cost.bookingFee | currency:currency():'symbol':'1.2-2' }}
              </span>
            </li>
          </ul>
          <div class="alert-confirmation__total">
            <span class="alert-confirmation__total-label">Total due</span>
            <span class="alert-confirmation__total-amount">
              {{ cost.totalDue | currency:currency():'symbol':'1.2-2' }}
            </span>
          </div>
          @if (cost.totalPaid != null) {
            <div class="alert-confirmation__total alert-confirmation__total--paid">
              <span class="alert-confirmation__total-label">Total paid</span>
              <span class="alert-confirmation__total-amount">
                {{ cost.totalPaid | currency:currency():'symbol':'1.2-2' }}
              </span>
            </div>
          }
          @if (paymentStatusLabel()) {
            <p class="alert-confirmation__payment-status alert-confirmation__payment-status--{{ cost.paymentStatus }}">
              {{ paymentStatusLabel() }}
            </p>
          }
        </section>
      }

      @if (canCancel()) {
        <button type="button"
                class="alert-confirmation__cancel"
                [disabled]="submitted()"
                (click)="cancelAlert()">
          Cancel notification
        </button>
      }
    </div>
  </div>
</article>
